import type { LabelMatingInfo } from '@/app/services/fertWork';

// WI 36046: Commercial labels and maps show donor and sire breed codes ("HO X JE").
export const COMMERCIAL_SIRE_BREED_FLAG = 'fert_work_commercial_sire_breed';

const MISSING = '\u2014';

export function formatBreedCodes(
  mating:
    | Pick<
        LabelMatingInfo,
        'breedCode' | 'donorBreed' | 'sireBreedCode' | 'sireBreed'
      >
    | null
    | undefined,
): string | null {
  if (!mating) return null;
  const donor = mating.breedCode?.trim() || mating.donorBreed?.trim();
  const sire = mating.sireBreedCode?.trim() || mating.sireBreed?.trim();
  if (!donor && !sire) return null;
  return `${donor || MISSING} X ${sire || MISSING}`;
}
